export const xIcon = require('./x-mark.png');
export const imgLogoBlack = require('./logo-black.png');
export const imgLogoBlackWide = 'https://firebasestorage.googleapis.com/v0/b/norway-92d0f.appspot.com/o/norway_wood_identity_%20horizontal.svg?alt=media';

export const imgWho = require('./who.jpg');
export const imgHow = require('./how_pc.jpeg');
export const imgHowMobile = require('./how_mobile.jpeg');

export const ourDirection1 = require('./ourDirection1.jpg');
export const ourDirection2 = require('./ourDirection2.jpg');